import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { normalizePremiumFolderData } from '../../../../utils/normalizePremiumFolderData';
import PremiumGallery from '@wix/da-ds/pkg/Icons/24x24/PremiumGallery';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/24x24/EyeDisc2';
import Points from '@wix/da-ds/pkg/Icons/Points';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import { getDeviationResourceType } from '../../../_helpers';
import Button, { ProfileOwnerWatchButton } from '../../../../Button';
import { Url } from '@wix/da-url';
import s from './PremiumCover.scss';
export const PremiumCover = ({ deviation: { premiumFolderData }, deviation })=>{
    var _deviation_author;
    const { t } = useTranslation();
    const { isPremiumLocked, isPaidFolder, isWatchToAccess, folderId, folderUrl, formattedDollarPrice, pointPrice, subproductId } = normalizePremiumFolderData(premiumFolderData);
    if (!isPremiumLocked) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: s['paywall-wrapper']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['paywall-cover']
    }, isPaidFolder && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PremiumGallery, {
        className: s['paywall-icon'],
        size: IconSize.BIG
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['paywall-title']
    }, t('deviation.paywall.premiumFolders.title')), /*#__PURE__*/ React.createElement("div", {
        className: s['cta-text']
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "deviation.paywall.premiumFolders.text"
    }, 'To view, unlock its ', /*#__PURE__*/ React.createElement(BiLink, {
        className: s['folder-preview-button'],
        href: folderUrl
    }, "Premium Deviation"), ' — and support the artist!')), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Button, {
        view: "b18",
        height: "medium",
        href: subproductId ? Url.checkoutLink(subproductId) : undefined,
        biData: BiData({
            evid: 361,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            authorid: (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.useridUuid,
            galleryid: folderId !== null && folderId !== void 0 ? folderId : 0,
            points: pointPrice,
            rank: BiContextProvidedValue,
            reason_shown: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            sectionid: BiContextProvidedValue,
            sectionname: BiContextProvidedValue,
            sectionrank: BiContextProvidedValue,
            sectiontype: BiContextProvidedValue,
            sort_type: BiContextProvidedValue,
            widgetname: BiContextProvidedValue
        })
    }, `Unlock for ${formattedDollarPrice} / `, /*#__PURE__*/ React.createElement(Points, {
        className: s['points-icon'],
        size: IconSize.TINY,
        disableDefaultColors: true
    }), `${pointPrice}`))), isWatchToAccess && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EyeDisc2, {
        className: s['paywall-icon'],
        size: IconSize.BIG
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['paywall-title']
    }, t('deviation.paywall.watchersOnly.title')), /*#__PURE__*/ React.createElement("div", {
        className: s['cta-text']
    }, t('deviation.paywall.watchersOnly.text')), deviation.author && /*#__PURE__*/ React.createElement(ProfileOwnerWatchButton, {
        className: s['watch-button'],
        user: deviation.author,
        onToggleWatchSuccess: ()=>{
            window.location.href = deviation.url;
        }
    }))));
};
PremiumCover.displayName = 'PremiumCover';
export default PremiumCover;
